import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

// import Custom Components
import OwlCarousel from '../features/owl-carousel';
import Service from '../features/service';
import QuickView from '../features/product/common/quickview';
import NewsletterModal from '../features/modal/newsletter-modal';
import Brand from '../features/brand';

import Introslide from './intro-slide';
import Sidebar from './sidebar';
import Banner from './banner';
import CTA from './cta-section';
import TrendyCollection from './trendy-collection';
import ProductCollection from './product-collection';

import { introSlider, homeBrandSlider } from '../settings';

import store from '../../store';

import data from '../../mock_data/data';
import style from './style.scss';

import './nvstyle.css';

import { connect } from 'react-redux';
import { getAllSliders } from '../../actions/slideActions';


function ListCategories() {
    let categories=[]

    for (let i = 1; i <= 18; i+=2) {

        categories.push(
            <ProductCollection
                category="Cooking"
                index={i}
                index2={i+1}
            />
        )
    }
        return categories

}
function HomePage( props ) {

    let slides = props.slides;


    const homeGroupe1 = slides.filter(item => item.blockKey == "HOME.GROUP1");
    const homeGroupe2 = slides.filter(item => item.blockKey == "HOME.GROUP2");
    const sidebarGroup = slides.filter(item => item.blockKey == "HOME.SIDEBAR");

    useEffect( () => {
        document.getElementById( "menu-home" ).classList.add( "active" );
        style.use();

        document.getElementById( "menu-home" ).classList.add( "active" );
        document.querySelector( ".category-dropdown" ).classList.add( "show" );
        document.querySelector( ".category-dropdown .dropdown-menu" ).classList.add( "show" );

        return ( () => {
            document.getElementById( "menu-home" ).classList.remove( "active" );
            style.unuse();
        } )
    }, [] )

    let i=1;
    return (
        <>
            <Helmet>
                <title>11&11 - Market</title>
            </Helmet>

            <h1 className="d-none">11&11 - Market</h1>

            <div className="main">
                <div className="mb-lg-2"></div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-10 col-xxl-10 offset-lg-3 offset-xxl-2">
                            <div className="intro-slider-container slider-container-ratio mb-2">
                                <OwlCarousel adClass="intro-slider owl-simple owl-nav-inside" carouselOptions={ introSlider }>
                                    {

                                        slides.map(  item  =>


                                            item.blockKey == "HOME.SLIDER" &&
                                                <Introslide slide={ item } key={ `${item.id}` } />


                                        )

                                    }
                                </OwlCarousel>

                                <span className="slider-loader"></span>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-10">


                            <ListCategories/>



                            <Service adClass="" />

                            <div className="mb-5"></div>
                        </div>

                        {/*<Brand adClass="owl-simple" sliderOption={ homeBrandSlider } count={ 7 } />*/}

                        <Sidebar banners={ sidebarGroup } />

                    </div>
                </div>
                <CTA />
            </div>

            {/*<NewsletterModal demo="14" />*/}
            <QuickView />
        </>
    )
}


const mapStateToProps = (state) => {
    return {
        slides: state.slides.slides ? state.slides.slides : [],
    }
}

export default  connect(mapStateToProps, { getAllSliders } ) (HomePage);